export const isDifferentDate = (date1: string, date2: string): boolean => {
  const [m1, d1, y1] = date1.split('/').map(Number);
  const [m2, d2, y2] = date2.split('/').map(Number);
  return m1 !== m2 || d1 !== d2 || y1 !== y2;
};
